import { render, staticRenderFns } from "./settlementEdit.vue?vue&type=template&id=2c708f77&scoped=true&"
import script from "./settlementEdit.vue?vue&type=script&lang=js&"
export * from "./settlementEdit.vue?vue&type=script&lang=js&"
import style0 from "./settlementEdit.vue?vue&type=style&index=0&id=2c708f77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c708f77",
  null
  
)

export default component.exports